import { Alert, Button, Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import BasicDateTimePicker from '@shared/components/BasicDateTimePicker';
import { type CreateVisitType } from '../../../../entity';
import { useReservationManualDate } from './reservation-manual-date.hooks';
import { validateDateFormat, validateIsTakenDate } from './reservation-manual-date.validation';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import dayjs from 'dayjs';

export const ReservationManualDate = () => {
  const { control, setValue } = useFormContext<CreateVisitType>();
  const { t } = useIntlTranslations('addVisitForm');
  const {
    visitsOnSelectedDate,
    showManualDatePickers,
    isDurationModified,
    serviceDurationMinutes,
    handleToggle,
  } = useReservationManualDate();

  return (
    <>
      <Button
        variant="outlined"
        fullWidth
        onClick={handleToggle}
        sx={{ mb: showManualDatePickers ? 1 : 0 }}
      >
        {showManualDatePickers ? t('hideManualDatePickers') : t('showManualDatePickers')}
      </Button>
      {showManualDatePickers && isDurationModified && (
        <Alert severity="error" sx={{ fontSize: '0.875rem' }}>
          {t('showManualDatePickersWarning')}
        </Alert>
      )}
      {showManualDatePickers && (
        <Stack spacing={2}>
          <BasicDateTimePicker
            fieldPath="date"
            control={control}
            onAccept={date => {
              if (!date) {
                return;
              }
              const duration = serviceDurationMinutes ?? 60;
              setValue('dateTo', dayjs(date).add(duration, 'minute').toDate());
            }}
            rules={{
              validate: {
                validateDateFormatFn: validateDateFormat(),
                validateIsTakenDate: validateIsTakenDate(visitsOnSelectedDate),
              },
            }}
          />
          <BasicDateTimePicker fieldPath="dateTo" control={control} label="Datum do" />
        </Stack>
      )}
    </>
  );
};
